import {Component, OnInit, Input, OnChanges, SimpleChanges, NgZone, AfterViewInit} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Overlay from 'ol/Overlay';
import GeoJSON from 'ol/format/GeoJSON';
import Select from 'ol/interaction/Select';
import {Stroke, Style, Fill, Circle as CircleStyle, Circle} from 'ol/style';
import {ImageWMS, OSM, TileWMS} from 'ol/source';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {click} from 'ol/events/condition';
import {toStringHDMS, toStringXY} from 'ol/coordinate';
import ImageLayer from 'ol/layer/Image';
import {MatDialog} from '@angular/material/dialog';
import XYZ from 'ol/source/XYZ';
import {Group} from "ol/layer";

import OlXYZ from 'ol/source/XYZ';
import OlTileLayer from 'ol/layer/Tile';
import OlView from 'ol/View';
import {AppService} from '../app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DragZoom} from "ol/interaction";
import Geolocation from 'ol/Geolocation';

import *  as ol from 'ol';


// import * from 'ol'
import * as events from "ol/events/condition";
import {Feature, MapBrowserEvent} from "ol";
import {CommunesList, Coordinate, SpacialData} from "../models/response.model";
import VectorTileLayer from 'ol/renderer/canvas/VectorTileLayer';
import {environment} from "../../environments/environment";
import {config} from "rxjs";
import {ScaleLine} from "ol/control";
import {fromLonLat, toLonLat} from "ol/proj";
import {coordinates} from "ol/geom/flat/reverse";
import {Point} from "ol/geom";


declare let $: any;
declare let Global: any;
declare let FixedMenu: any;
declare let FormWizard: any;
declare let ScroolGlobal: any;

class cdt implements Coordinate {
  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  x: number;
  y: number;

}


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {
  // url3 = "http://172.17.0.40:8600/geoserver/efb/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=efb%3Aefb&outputFormat=application%2Fjson"
  // url = "https://test.andf.bj:9443/geoserver/efb/wms";
  // url = "https://cadastre.andf.bj:9443/geoserver/efb/wms"
  commune: CommunesList = [];
  radarStyle: { [key: string]: string } = {};
  radarActive = true;
  coord: any;
  config = environment;
  url = this.config.GEOSERVER_URL + `/geoserver/${this.config.GEOSERVER_WORKSPACE}/wms`;
  title = 'OpenLayers';
  map;
  spacialInformation: SpacialData = null;
  source: OlXYZ;
  // @ts-ignore
  layers: OlTileLayer;
  view: OlView;
  Info: any;
  vectorSource: any;
  select = null;
  datas: {};
  nup;
  Tfoncier;
  Dep;
  Com;
  Arr;
  Qrtier;
  lot;
  Parcelle;
  Surface;
  DateF;
  defaultNameSpace = 'efb:efb_parcel_prod';
  action;
  greenColor = "#008000"
  lightgreenColor = "#90EE90"
  orangeColor = "#FFA500"
  ligthorangeColor = "#FFFFE0"
  grayColor = "#778899"
  //v/ 909226.3631854871&lon=432371.96549791255&zoom=8

  defaultCoordinate: cdt = new cdt(432371.96549791255, 909226.3631854871)
  googleStatLayers: OlTileLayer<any>;
  osmLayers: OlTileLayer<any>;
  beninOrthoLayer: ImageLayer<any>;
  olgmLayers: OlTileLayer<any>;
  sourceLayersnum: ImageLayer<any>;
  sourceLayerClic: ImageLayer<any>;
  sourceLayersvilage: ImageLayer<any>;
  sourceLayers: ImageLayer<any>;

  Data: any
  features: any[] = []
  openMap: any;
  openMapCh: any;
  googleMap = true;
  streetMapp = true;
  MapOSM = true;
  MapOLGM = false;
  MapOrtho = false;

  Loading = false;
  village: any;
  search: any
  TypeMap = [
    // {name: 'Parcelles Cadastrales', value: 'PAR'},
    {name: 'Open Street Map', value: 'OSM'},
    {name: 'Google Maps', value: 'OLGM'},
    // {name: 'Orthophoto', value: 'ORTHO'}
  ];
  showForm = false;
  code = this.activatedroute.snapshot.paramMap.get('nup');
  private defauldtZoom: number = this.config.OPENLAYERS_MIN_ZOOM;

   positionFeature = new Feature();
  accuracyFeature = new Feature();


  constructor(
    private _appServices: AppService,
    private activatedroute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _router: Router,
    public dialog: MatDialog,
    private ngZone: NgZone,
  ) {

    this.positionFeature.setStyle(new Style({
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color: '#3399CC'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 2
        })
      })
    }));
  }

  ngAfterViewInit(): void {
    $('#myModal').modal({backdrop: 'static', keyboard: false})
    Global()
  }

  loader() {

    this.Loading = true;
    setTimeout(() => {
      this.Loading = false;
    }, 2000)
  }

  ngOnInit(): void {

    this.loader();
    // this.coord = "Commune";
    if (this.code) {
      // console.log(this.code)
      this.showForm = true;
      this.getInformation()
    } else {
      //  this.communes();
      this.initilizeMap()
      this.flyTo([this.defaultCoordinate.x, this.defaultCoordinate.y], function () {
      }, this.defauldtZoom)
      this.showForm = false;
    }
    this.openMap = 'OSM'
    this.openMapCh = 'OSM'
  }

  open() {
    $("#myModal").modal({
      backdrop: 'static',
      keyboard: false,
      show: true,
    })
  }

  openMapStreet() {
    // console.log('Valeur:', this.openMap );

    if (this.openMap === 'OSM') {
      this.MapOSM = true
      this.MapOLGM = false
      this.MapOrtho = false
      this.osmLayers.setVisible(true)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    } else if (this.openMap === 'OLGM') {
      this.MapOSM = false
      this.MapOLGM = true
      this.MapOrtho = false
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(true)
      this.olgmLayers.setVisible(true)
    } else if (this.openMap === 'ORTHO') {
      this.MapOSM = false
      this.MapOLGM = false
      this.MapOrtho = true
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(true)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    } else if (this.openMap === 'PAR') {
      this.MapOSM = false
      this.MapOLGM = false
      this.MapOrtho = false
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    }
  }

  openMapStreetCheck() {
    // console.log('Valeur:', this.openMap );

    if (this.openMapCh === 'OSM') {
      this.MapOSM = true
      this.MapOLGM = false
      this.MapOrtho = false
      this.osmLayers.setVisible(true)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    } else if (this.openMapCh === 'OLGM') {
      this.MapOSM = false
      this.MapOLGM = true
      this.MapOrtho = false
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(true)
      this.olgmLayers.setVisible(true)
    } else if (this.openMapCh === 'ORTHO') {
      this.MapOSM = false
      this.MapOLGM = false
      this.MapOrtho = true
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(true)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    } else if (this.openMapCh === 'PAR') {
      this.MapOSM = false
      this.MapOLGM = false
      this.MapOrtho = false
      this.osmLayers.setVisible(false)
      this.beninOrthoLayer.setVisible(false)
      this.googleStatLayers.setVisible(false)
      this.olgmLayers.setVisible(false)
    }
  }

  googleMapStreet() {
    console.log(this.googleMap)

    if (this.googleMap === true) {
      this.googleMap = false
    } else {
      this.googleMap = true
    }
  }

  close() {
    $('#myModal').modal({
      show: false,
    });
    location.reload()
  }


  initilizeMap() {

    const color = '';
    let styleNew = new Style({
      stroke: new Stroke({
        color: color,
        width: 7,
      })
    });
    proj4.defs(
      'EPSG:32631',
      '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs',
    );
    register(proj4);

    const mwsSources2 = new ImageWMS({
      // url: 'https://cadastre.bj/geoserver/benin/wms',
      url: this.url,
      params: {'LAYERS': 'andf-ortho'},
      ratio: 1,
      serverType: 'geoserver',
    });
    // console.log(this.village, this.code)
    const mwsSourcesnup = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': 'nup=' + this.code, 'STYLES': 'sst'},
      ratio: 1,
      serverType: 'geoserver',

    });
    const mwsSourcesVillage = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': `quartier_name='${this.village}' `},
      ratio: 1,
      serverType: 'geoserver',

    });
    const mwsSources = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace},
      ratio: 1,
      serverType: 'geoserver',
    });

    // vue par defaut
    let views = new View({
      center: [this.defaultCoordinate.x, this.defaultCoordinate.y],
      projection: 'EPSG:32631',
      zoom: this.defauldtZoom,
      minZoom: this.config.OPENLAYERS_MIN_ZOOM
    });

    // google layer
    this.googleStatLayers = new TileLayer({
      source: new XYZ({
        url: 'http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}'
      }),
      visible: false,
      opacity: 0.5
    });
// Benin ortho photo
    this.beninOrthoLayer = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSources2,
      visible: false,
      opacity: 0.7
    })

    this.olgmLayers = new TileLayer({
      source: new XYZ({
        url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}'
      }),
      visible: false,
      opacity: 0.5
    });

    this.osmLayers = new TileLayer({
      source: new OSM(),
      // visible: true,
      opacity: 0.7
    })

    this.sourceLayers = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSources,
      opacity: 0.7,
    })

    this.sourceLayersvilage = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesVillage,
      opacity: 0.7,
      visible: true
    })

    this.sourceLayersnum = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesnup,
      opacity: 0.7,
      visible: true,
      // minZoom: 18
    })

    if (this.code) {
      this.sourceLayers.setVisible(false)
      this.sourceLayersnum.setOpacity(1)
      this.sourceLayersnum.setZIndex(1)
      views = new View({
        center: [this.spacialInformation.data.coordinate.x, this.spacialInformation.data.coordinate.y],
        projection: 'EPSG:32631',
        zoom: this.getZoom(this.spacialInformation.data.calculatedArea),
        minZoom: 8
      });
    }
    // show coordonate
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    // const closer = document.getElementById('popup-closer');
    /**
     * Create an overlay to anchor the popup to the map.
     */
    const overlay = new Overlay({
      element: container,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
    /**
     * Add a click handler to hide the popup.
     * @return {boolean} Don't follow the href.
     */
    /*  closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };*/

    const layers = [
      new TileLayer({
        source: new OSM({
          attributions: ''
        }),
        visible: true
      }),
      this.olgmLayers,
      this.beninOrthoLayer,
      this.googleStatLayers,
      this.sourceLayers,
      this.sourceLayersvilage,
      this.sourceLayersnum
    ];

    this.map = new Map({
      layers: new Group({
        layers: layers,
      }),
      overlays: [overlay],
      target: 'map',
      view: views,

    });

    this.map.addControl(new ScaleLine({
      target: document.getElementById('scaleline'),
    }))
    // @ts-ignore
    this.map.on('onload', (evt: MapBrowserEvent): void => {
      console.log('event ', evt);
      let url = mwsSources.getFeatureInfoUrl(
        evt.coordinate,
        views.getResolution(),
        views.getProjection(), {
          'INFO_FORMAT': 'application/json'
        });
      if (url) {
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            this.Info = data.features[0].properties
            let d = data.features[0].properties
            this.getInfoFromLocalStorage(d)
          });
        // this.map.zoomToMaxExtent();
      }
    });

    this.map.on('loadstart', () => {
      this.map.getTargetElement().classList.add('spinner');
    });
    this.map.on('loadend', () => {
      this.map.getTargetElement().classList.remove('spinner');
    });

    // @ts-ignore
    this.map.on('singleclick', (evt: MapBrowserEvent) => {
      console.log('event ', evt);
      console.log('Cordinate. ', evt.coordinate);
      // this.centerMap(evt.coordinate)
      let url = mwsSources.getFeatureInfoUrl(
        evt.coordinate,
        views.getResolution(),
        views.getProjection(), {
          'INFO_FORMAT': 'application/json'
        });

      if (url) {
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            this.Info = data.features[0].properties
            let d = data.features[0].properties
            this.map.getLayers().array_.push(this.clicLayer(d.nup))
            this.flyTo(evt.coordinate, () => {
              this.getInfoFromLocalStorage(d)
            }, this.getZoom(d.calculated_area))
            // this.centerMap(evt.coordinate, d.calculated_area)

            // this.map.setLayers(this.clicLayer(d.nup))
          });
        // this.map.zoomToMaxExtent();
      }
      this.showForm = false;
    });
    /**
     * Add a click handler to the map to render the popup.
     */

    var div = document.getElementsByClassName("ol-scale-line");
    const newDiv = document.createElement("div");
    newDiv.className = 'ol-scale-line-inner';
    const newContent = document.createTextNode("|");
    newDiv.appendChild(newContent);
    div[0].appendChild(newDiv)
    // div= newDiv;
    // var div =  document.getElementsByClassName("ol-scale-line-inner");

    // this.map.on('pointermove', function (evt) {
    this.map.on('pointermove', function (evt) {
      const coordinate = evt.coordinate;
      const hdms = toStringHDMS(toLonLat(coordinate));

      newDiv.innerHTML=toStringXY(coordinate,1);

      // console.log('div ',div)

      // div.innerHTML =div.innerHTML+ '| '+toStringXY(coordinate,1);



      // var newDiv = document.getElementById("cdt").innerHTML= '<code>' + toStringXY(coordinate,1) + '</code>';
      // var newDiv = document.getElementById("cdt").innerHTML= '<code>' + toStringXY() toLonLat(coordinate) + '</code>';
      // newDiv.children.namedItem("div").innerHTML = '<code>' + toLonLat(coordinate) + '</code>';

      // content.innerHTML = '<code>' + hdms + '</code> <br> <code>' +toStringXY(coordinate,1)+ '</code>';
      // content.innerHTML = '<p>You clicked here:</p><code>' + hdms + '</code>';
      // overlay.setPosition(coordinate);
    });

  }

  private getZoom(calculatedArea: number) {
    let zoom = 15;
    if (calculatedArea < 500) {
      zoom = 20;
    } else if (calculatedArea > 500 && calculatedArea < 10000) {
      zoom = 19;
    } else if (calculatedArea > 10000 && calculatedArea < 50000) {
      zoom = 17;
    } else if (calculatedArea > 50000) {
      zoom = 15;
    }
    return zoom;
  }

  flyTo(location, done, pZoom) {
    const duration = 4000;
    const view = this.map.getView();

    let zoom = this.defauldtZoom;
    if (pZoom) {
      zoom = pZoom
    }
    let parts = 2;
    let called = false;

    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;
        done(complete);
      }
    }

    view.animate(
      {
        center: location,
        duration: duration,
      },
      callback
    );
    view.animate(
      {
        zoom: zoom - 1,
        duration: duration / 2,
      },
      {
        zoom: zoom,
        duration: duration / 2,
      },
      callback
    );
  }

  centerMap(c, calculatedArea) {
    console.log("c: " + c);

    this.map.getView().setCenter(c, 'EPSG:32631');
    // this.map.getView().animate({
    //     center: c,
    //     duration: 2000,
    //     projection: 'EPSG:32631'
    //     // easing: elastic,
    //   }
    // )
    if (calculatedArea) {
      console.log('Zoom : ', this.getZoom(calculatedArea))
      this.map.getView().setZoom(this.getZoom(calculatedArea));
    } else {
      this.map.getView().setZoom(this.defauldtZoom);
    }


  }


  getInfoFromLocalStorage(d) {
    //let info = JSON.parse(localStorage.getItem('INFO'))
    this.nup = d.nup;
    this.code = d.nup;
    this.Tfoncier = d.title_number_number;
    this.Dep = d.departement_name;
    this.Com = d.commune_name;
    this.Arr = d.arrondissement_name;
    this.Qrtier = d.quartier_name;
    this.lot = d.ilot;
    this.Surface = d.calculated_area;
    this.Parcelle = d.register_type;
    if (this.Parcelle === "publicDomain") {
      this.Parcelle = 'Domaine public'
    } else if (this.Parcelle === "privateParcel") {
      this.Parcelle = 'Parcelle privée'
    } else if (this.Parcelle === "naturalPublicDomain") {
      this.Parcelle = 'Domaine public naturel'
    }
    this.DateF = "-";
    $("#myModal").modal('show')
    $("#myModal").on("hidden.bs.modal", () => {
      // put your default event here
      this.sourceLayerClic.setVisible(false);
      // console.log("closed .....",this.map.getLayers().array_.length)
      // this.map.getLayers().array_.pop()
      // console.log("closed .....",this.map.getLayers().array_.length)

    });
    //  return info
  }

  changeViewDone() {
    console.log('view done')
  }

  // Recuperation de coordonnée
  getCoordinate(value) {
    const cmn = this.getCommune(value);
    const cord = new cdt(cmn.coordinate.x, cmn.coordinate.y);
    // this.centerMap([cmn.coordinate.x,cmn.coordinate.y] ,null);
    this.flyTo([cmn.coordinate.x, cmn.coordinate.y], function () {
    }, null)
  }

  communes() {
    return this._appServices.getCommune().subscribe((res: CommunesList) => {
      this.commune = res
      if (this.commune) {
        const cmn = this.commune[0];
        console.log(this.commune)
        this.coord = cmn.insaeCode;
        this.flyTo([cmn.coordinate.x, cmn.coordinate.y], function () {
        }, null)
      }
    })
  }


  getCommune(insaeCode) {
    return this.commune.find(x => x.insaeCode === insaeCode);
  }


  SearchByNup(keys) {

    this._appServices.getNupInfo(keys).subscribe((res: SpacialData) => {
      console.log(res)
      this.spacialInformation = res;
      console.log(res.data)
      if (res.message === "ParcelExists") {
        this._router.navigate(["/nup", keys])
        let d = res.data
        // this.village = "'" + d.quartierName + "'"
        this.village = d.quartierName
        console.log(this.village)
        this.nup = d.nup;
        this.Tfoncier = d.titleNumberNumber;
        this.Dep = d.departementName;
        this.Com = d.communeName;
        this.Arr = d.arrondissementName;
        this.Qrtier = d.quartierName;
        this.lot = d.ilot;
        this.Surface = d.calculatedArea;
        this.Parcelle = d.registerType;

        if (this.Parcelle === "publicDomain") {
          this.Parcelle = 'Domaine public'
        } else if (this.Parcelle === "privateParcel") {
          this.Parcelle = 'Parcelle privée'
        } else if (this.Parcelle === "naturalPublicDomain") {
          this.Parcelle = 'Domaine public naturel'
        } else if (this.Parcelle === "artificialPublicDomain") {
          this.Parcelle = 'Domaine public artificiel'
        }
        this.DateF = "-";
        // $("#myModal").modal('show')
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle trouvée", "Fermer",);
        }, 3000);
      } else if (res.message === "ParcelNotExists") {
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle non trouvée", "Fermer");
        }, 3000);

      }

    })
  }

  getInformation() {

    this._appServices.getNupInfo(this.code).subscribe((res: SpacialData) => {
      console.log(res)
      this.spacialInformation = res;
      console.log(res.data)
      if (res.message === "ParcelExists") {
        let d = res.data
        // this.village = "'" + d.quartierName + "'"
        this.village = d.quartierName
        console.log(this.village)
        this.nup = d.nup;
        this.Tfoncier = d.titleNumberNumber;
        this.Dep = d.departementName;
        this.Com = d.communeName;
        this.Arr = d.arrondissementName;
        this.Qrtier = d.quartierName;
        this.lot = d.ilot;
        this.Surface = d.calculatedArea;
        this.Parcelle = d.registerType;
        if (this.Parcelle === "publicDomain") {
          this.Parcelle = 'Domaine public'
        } else if (this.Parcelle === "privateParcel") {
          this.Parcelle = 'Parcelle privée'
        } else if (this.Parcelle === "naturalPublicDomain") {
          this.Parcelle = 'Domaine public naturel'
        } else if (this.Parcelle === "artificialPublicDomain") {
          this.Parcelle = 'Domaine public artificiel'
        }
        this.DateF = "-";
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle trouvée", "Fermer",);
        }, 3000);
      } else if (res.message === "ParcelNotExists") {
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle non trouvée", "Fermer");
        }, 3000);

      }

    })
  }

  close_pop_up() {
    this.showForm = false;
    console.log('Fermer ')
  }

  clicLayer(nup) {
    const mwsSourcesnup = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': 'nup=' + nup, 'STYLES': 'sst'},
      ratio: 1,
      serverType: 'geoserver',

    });
    this.sourceLayerClic = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesnup,
      opacity: 0.8,
      visible: true,
      // minZoom: 18
    })
    return this.sourceLayerClic;
  }

  getGeoPoistion() {
    console.log('getGeoPoistion')

    const geolocation = new Geolocation({
      tracking: true,
      trackingOptions: {
        enableHighAccuracy: true,
        maximumAge: 2000
      },
      projection: this.map.getView().getProjection()
    });


    geolocation.on('change', () => {
      const position = geolocation.getPosition();
      this.accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
      console.log(position);
      this.positionFeature.setGeometry(position ?
        new Point(position) : null);
      this.map.getView().setCenter(position);
      this.map.getView().setZoom(18);
      const vectorSource = new VectorSource();
      vectorSource.addFeature(this.positionFeature);
      // this.map.getLayers().array_.push(this.positionFeature)
      // this.map.getView().fit(vectorSource.getExtent());
      // Mettez à jour la position de l'élément radar en fonction de la nouvelle position.
      this.radarActive = true;
      //@ts-ignore
      this.radarStyle = {
        left: position[0] - 25 + 'px',
        top: position[1] - 25 + 'px'
      };

      new VectorLayer({
        map: this.map,
        source: new VectorSource({
          features: [ this.accuracyFeature,this.positionFeature],
        }),
      });


    });
  }
}

